import { useEffect, useState } from "react";
import { IAnswer } from "../../models/dto/surveyApi/IAnswerDto";
import { IOption } from "../../models/dto/surveyApi/IOptionDto";
import { IQuestion } from "../../models/dto/surveyApi/IQuestionDto";
import { ISurveyAnswerDto } from "../../models/dto/surveyApi/ISurveyAnswerDto";
import { QuestionTypeEnum } from "../../models/enum/QuestionTypeEnum";
import solveSurveyService from "../../services/surveyApi/solveSurvey.service";

export const useSurvey = ({ route, webcamRef }: any) => {
    const [questions, setQuestions] = useState<IQuestion[]>([])
    const [survey] = useState<any>();
    const [answers, setAnswers] = useState<IAnswer[]>([])
    const [currentQuestion, setCurrentQuestion] = useState(0)
    const [saved, setSaved] = useState(false);
    const [cancelSave, setCancelSave] = useState(false);
    const [screenView, setScreenView] = useState<number[]>([]);
    const [isSave, setIsSave] = useState(false);
    const [show, setShow] = useState(false);
    const [next, setNext] = useState(false);
    const [back, setBack] = useState(true);
    const [showCamera, setShowCamera] = useState(false);
    const [openModalSave, setOpenModalSave] = useState(false);
    const [answersSent, setAnswersSent] = useState(false);
    const [hasCamera, setHasCamera] = useState<boolean | null>(null);

    const handleResetSurvey = () => {
        const mockSurveyCopy = [...questions];
        mockSurveyCopy.forEach((question: IQuestion) => {
            question.Options.forEach((choice: IOption) => {
                choice.selected = false;
            });
        });
        setQuestions(mockSurveyCopy);
    }

    const handleSaveSurvey = () => {
        const mockSurveyCopy = [...questions];
        mockSurveyCopy.forEach((question: IQuestion) => {
            question.Options.forEach((choice: IOption) => {
                choice.selected = false;
            });
        });
        setQuestions(mockSurveyCopy);
        const answerSave: ISurveyAnswerDto = {
            ANSWER: JSON.stringify(answers.map((answer) => {
                return {
                    QuestionID: answer.idQuestion,
                    Answer: answer.answer,
                    Photo: answer.photo,
                }
            })), DATE_ANSWERED: new Date(), ID_SURVEY: route.surveyId, POS_CODE: route.posCode
        };
        solveSurveyService.postSurveyAnswers(answerSave)
            .then(r => {
                resetStates();
                setAnswersSent(true);
            });
    }

    const resetStates = () => {
        setOpenModalSave(false);
        setSaved(false);
        setQuestions([])
        setAnswers([])
        setCurrentQuestion(0)
    }

    useEffect(() => {
        navigator.mediaDevices
            .getUserMedia({ video: true, audio: false })
            .then((stream: any) => {
                setHasCamera(true);
                stream.getTracks()[0].stop();
            })
            .catch(() => setHasCamera(false));
    }, [])


    useEffect(() => {
        if (cancelSave) {
            setSaved(false);
            setCancelSave(false);
            onPressPrevious();
            setOpenModalSave(false);
        }

        if (isSave) {
            setSaved(false);
            setCancelSave(false);
            setIsSave(false);
            setOpenModalSave(false);
            handleSaveSurvey();
        }
    }, [cancelSave, saved, isSave]);

    useEffect(() => {
        if (!answersSent) {
            const actualQuestion = questions[currentQuestion];

            if (currentQuestion > questions.length - 1 && questions.length > 0) {
                setSaved(true);
                setOpenModalSave(true);
                setCancelSave(false);
            }

            if (actualQuestion?.Condition !== '') {
                const parentQuestion = questions.filter((question) => question.QuestionID === actualQuestion?.Parent)[0];
                const parentAnswer = answers.filter((answer) => answer.question === parentQuestion?.Question)[0];

                // if parent answer is an array
                if (Array.isArray(parentAnswer?.answer)) {
                    if (!parentAnswer?.answer.includes(actualQuestion?.Condition)) {
                        const answer = answers.filter((answer) => answer.id !== currentQuestion);
                        setAnswers(answer)

                        const answersId = answers.map((answer) => answer.idQuestion);
                        questions.forEach((question) => {
                            if (!answersId.includes(question.QuestionID)) {
                                question.Options.forEach((option) => {
                                    option.selected = false;
                                });
                            }
                        });
                        setCurrentQuestion((prev) => prev + 1)
                    } else {
                        if (!screenView.includes(currentQuestion)) {
                            setScreenView((prev) => [...prev, currentQuestion])
                        }
                    }
                } else {
                    if (parentAnswer?.answer !== actualQuestion?.Condition) {
                        const answer = answers.filter((answer) => answer.id !== currentQuestion);
                        setAnswers(answer)

                        const answersId = answers.map((answer) => answer.idQuestion);
                        questions.forEach((question) => {
                            if (!answersId.includes(question.QuestionID)) {
                                question.Options.forEach((option) => {
                                    option.selected = false;
                                });
                            }
                        });
                        setCurrentQuestion((prev) => prev + 1)
                    } else {
                        if (!screenView.includes(currentQuestion)) {
                            setScreenView((prev) => [...prev, currentQuestion])
                        }
                    }
                }
            } else if (actualQuestion?.Condition === '') {
                if (!screenView.includes(currentQuestion)) {
                    setScreenView((prev) => [...prev, currentQuestion])
                }
            }
        }
    }, [currentQuestion, saved])

    useEffect(() => {
        const actualQuestion = questions[currentQuestion];

        if (actualQuestion?.MandatoryQuestion === true || actualQuestion?.MandatoryPhoto === true) {
            setNext(false);
            const answer = answers.filter((answer) => answer.idQuestion === actualQuestion.QuestionID)[0];
            if (!answer && actualQuestion?.MandatoryQuestion === true) {
                setNext(false);
            } else if (answer && answer.answer.length === 0 && actualQuestion?.MandatoryQuestion === true) {
                setNext(false);
            } else if (actualQuestion?.MandatoryPhoto === true && !answer?.photo) {
                setNext(false);
            } else {
                setNext(true);
            }
        } else if (actualQuestion?.MandatoryQuestion === false && actualQuestion?.MandatoryPhoto === false) {
            setNext(true);
        }

    }, [answers, currentQuestion, questions])

    const onPressNext = () => {
        setShow(false);
        setCurrentQuestion((prev) => prev + 1)
    }

    const onPressPrevious = () => {
        setShow(false);
        const actualQuestion = screenView[screenView.length - 1];
        const lastQuestion = screenView[screenView.length - 2];
        setCurrentQuestion(lastQuestion)
        const newScreenView = screenView.filter((question) => question !== actualQuestion);
        setScreenView(newScreenView);
    }

    const handleRadioPress = (selection: string, index: string) => {
        let question = questions[currentQuestion];
        question.Options.forEach((option, i) => {
            if (i.toString() === index) {
                option.selected = !option.selected;;
            } else {
                option.selected = false;
            }
        });
        setQuestions([...questions]);

        const answer = answers.filter((answer) => answer.id !== currentQuestion);
        const selectChoices = question.Options.filter((option) => option.selected);
        const selectChoicesString = selectChoices.map((option) => option.Option).join('| ');

        const actualAnswer = answers.filter((answer) => answer.id === currentQuestion);

        if (actualAnswer.length > 0) {
            setAnswers([...answer, { id: currentQuestion, idQuestion: question.QuestionID, question: questions[currentQuestion].Question, answer: selectChoicesString, photo: actualAnswer[0].photo, type: 2 }])
        } else {
            setAnswers([...answer, { id: currentQuestion, idQuestion: question.QuestionID, question: questions[currentQuestion].Question, answer: selectChoicesString, photo: null, type: 2 }])
        }
    }

    const handleCheckboxPress = (selection: string, index: string) => {
        let question = questions[currentQuestion];
        question.Options.forEach((option, i) => {
            if (i.toString() === index) {
                option.selected = !option.selected;
            }
        });
        setQuestions([...questions]);

        const answer = answers.filter((answer) => answer.id !== currentQuestion);
        const selectChoices = question.Options.filter((option) => option.selected);
        const selectChoicesString = selectChoices.map((option) => option.Option).join('| ');

        const actualAnswer = answers.filter((answer) => answer.id === currentQuestion);

        if (actualAnswer.length > 0) {
            setAnswers([...answer, { id: currentQuestion, idQuestion: question.QuestionID, question: questions[currentQuestion].Question, answer: selectChoicesString, photo: hasCamera ? actualAnswer[0].photo : 'Client does not have camera', type: QuestionTypeEnum.checkbox }])
        } else {
            setAnswers([...answer, { id: currentQuestion, idQuestion: question.QuestionID, question: questions[currentQuestion].Question, answer: selectChoicesString, photo: hasCamera ? null : 'Client does not have camera', type: QuestionTypeEnum.checkbox }])
        }
    }

    const handleTextInput = (text: string) => {
        const answer = answers.filter((answer) => answer.id !== currentQuestion);

        const actualAnswer = answers.filter((answer) => answer.id === currentQuestion);

        if (actualAnswer.length > 0) {
            setAnswers([...answer, { id: currentQuestion, idQuestion: questions[currentQuestion].QuestionID, question: questions[currentQuestion].Question, answer: text, photo: hasCamera ? actualAnswer[0].photo : 'Client does not have camera', type: QuestionTypeEnum.text }])
        } else {
            setAnswers([...answer, { id: currentQuestion, idQuestion: questions[currentQuestion].QuestionID, question: questions[currentQuestion].Question, answer: text, photo: hasCamera ? null : 'Client does not have camera', type: QuestionTypeEnum.text }])
        }
    }

    const handleStarPress = (selection: string, index: string) => {
        let question = questions[currentQuestion];
        question.Options.forEach((option, i) => {
            if (i.toString() <= index) {
                option.selected = true;
            } else {
                option.selected = false;
            }
        });
        setQuestions([...questions]);

        const answer = answers.filter((answer) => answer.id !== currentQuestion);
        const actualAnswer = answers.filter((answer) => answer.id === currentQuestion);

        if (actualAnswer.length > 0) {
            setAnswers([...answer, { id: currentQuestion, idQuestion: question.QuestionID, question: questions[currentQuestion].Question, answer: selection, photo: hasCamera ? actualAnswer[0].photo : 'Client does not have camera', type: QuestionTypeEnum.star }])
        } else {
            setAnswers([...answer, { id: currentQuestion, idQuestion: question.QuestionID, question: questions[currentQuestion].Question, answer: selection, photo: hasCamera ? null : 'Client does not have camera', type: QuestionTypeEnum.star }])
        }
    }



    const takePhotoFromGallery = async () => {
        let imageSrc = webcamRef.current.getScreenshot();
        if (imageSrc) {
            const answer = answers.filter((answer) => answer.id !== currentQuestion);
            const actualAnswer = answers.filter((answer) => answer.id === currentQuestion);
            if (actualAnswer.length > 0) {
                const newAnswer = actualAnswer.map((answer) => {
                    return {
                        ...answer,
                        photo: imageSrc
                    }
                })
                await setAnswers([...answer, ...newAnswer])
            } else {
                await setAnswers([...answer, { id: currentQuestion, idQuestion: questions[currentQuestion].QuestionID, question: questions[currentQuestion].Question, answer: '', photo: imageSrc, type: questions[currentQuestion].Type }])
            }
        }
        setShowCamera(false);
    }

    const deletePhoto = () => {
        const answer = answers.filter((answer) => answer.id !== currentQuestion);
        const actualAnswer = answers.filter((answer) => answer.id === currentQuestion);

        if (actualAnswer.length > 0) {
            const newAnswer = actualAnswer.map((answer) => {
                return {
                    ...answer,
                    photo: null
                }
            })
            setAnswers([...answer, ...newAnswer])
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(true);
        }, 100);
        return () => {
            setShow(false);
            clearTimeout(timer)
        };
    }, [currentQuestion, setCurrentQuestion]);

    return {
        questions,
        answers,
        currentQuestion,
        saved,
        show,
        survey,
        next,
        back,
        showCamera,
        openModalSave,
        answersSent,
        hasCamera,
        setOpenModalSave,
        onPressNext,
        setQuestions,
        onPressPrevious,
        handleRadioPress,
        handleCheckboxPress,
        handleTextInput,
        setCancelSave,
        setIsSave,
        handleResetSurvey,
        handleStarPress,
        takePhotoFromGallery,
        deletePhoto,
        setBack,
        setShowCamera,
        setAnswersSent
    }
}